import React, { useState } from 'react';
import { Save, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/AxiosInstance';
import { endpoints } from '../services/endpoints';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';

const AdminChangePassword = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [saving, setSaving] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
            showErrorToast('All password fields are required');
            return;
        }

        if (form.newPassword.length < 8) {
            showErrorToast('Password must be at least 8 characters long');
            return;
        }

        if (form.newPassword !== form.confirmPassword) {
            showErrorToast('New password and confirm password do not match');
            return;
        }

        setSaving(true);
        try {
            await axiosInstance.post(endpoints.changePassword, {
                currentPassword: form.currentPassword,
                newPassword: form.newPassword,
            });
            setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
            showSuccessToast('Password changed successfully');
        } catch (error) {
            showErrorToast(error?.response?.data?.message || 'Failed to change password');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <div className="page_top_section">
                <div className="page-header">
                    <div className="page-header-left d-flex align-items-center">
                        <div className="page-header-title">
                            <nav className="breadcrumb_nav mb-3">
                                <ul className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">Admin</li>
                                    <li className="breadcrumb-item text-capitalize">Reset Password</li>
                                </ul>
                            </nav>
                            <h1 className="fs-3 text-black fw-semibold mb-0 text-capitalize">Reset Password</h1>
                            <p className="text-clr mb-0">Change your admin password securely</p>
                        </div>
                    </div>
                </div>
            </div>

            <section className="main-section common_section spacer">
                <div className="container">
                    <form className="outline_blk admin-profile-form position-relative" onSubmit={handleSubmit}>
                        <button className="profile-close-btn" type="button" onClick={() => navigate('/admin-dashboard')} aria-label="Close">
                            <X />
                        </button>

                        <div className="row gy-4">
                            <div className="col-12">
                                <label className="form-label">Current Password</label>
                                <input className="form-control" type="password" name="currentPassword" value={form.currentPassword} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className="form-label">New Password</label>
                                <input className="form-control" type="password" name="newPassword" value={form.newPassword} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Confirm Password</label>
                                <input className="form-control" type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} />
                            </div>
                        </div>

                        <div className="mt-4">
                            <button className="primary-btn" type="submit" disabled={saving}>
                                <Save />
                                <span className="btntext">{saving ? 'Saving...' : 'Save Changes'}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
};

export default AdminChangePassword;
